import { keys } from '../../query/keyRegistry';

/** Shared with legacy subscriptionKeys.detail — same cache during WIRE. */
export const subscriptionKeys = {
  detail: (customer_id: number) => keys.customer(customer_id).subscription,
};
